import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import axios from "axios"

const { Option } = Select 

/**
 * @const SelectCentrosCostos
 * @description Select para los centros de costos registrados en el sistema, estos tiene que estar ligados a un cliente
 */
const SelectCentrosCostos = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el centro de costo", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null,
        labelInValue,
        url = '/customer/centros',
    } = props

    const [ centros, setCentroCostos ] = useState({
        data: [],
        page: 1,
        limit: 100,
        total: 0,
        search: null,
    })


    /**
     * @const getCentrosCostos
     * @description Obitiene los centros de costos registrados en el sistema
     */
    const getCentrosCostos = ({
        page, 
        limit, 
        search, 
    } = centros) => {

        axios.get(url, {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            console.log('data',data);
            setCentroCostos({data: data.data})
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los centros de costos')
        })
    }

    //componentDidMount
    useEffect(() => {
        getCentrosCostos()
    }, [])


    return (
        <Select
            variant={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getCentrosCostos({search})}
            onSelect={(area)=> {
                if(mode === null && !labelInValue){
                    onChange(area.value)
                    onSelect(area.value)
                }
                if(mode === null && labelInValue){
                    onChange(area)
                    onSelect(area)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple" && !labelInValue){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }

                if(mode === "multiple" && labelInValue){
                    onChange(values)
                    onSelect(values)
                }
            }}
            value={value}
            onClear={() => {
                onClear();
                if (mode === "multiple") {
                  //onChange([]);
                  onSelect([]);
                } else {
                  onChange(undefined);
                  onSelect(undefined);
                }
            }}
        >
            {
                centros?.data?.map(({ _id, nombre, limite }) => (
                    <Option value={_id} key={_id}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span >{nombre ?? ""}</span>
                            <span style={{ marginLeft: 8, fontSize: 10 }}>{limite ? `$ ${limite.toMoney(true)} MXN` : "-"}</span>
                        </div>
                    </Option>
                ))
            }
        </Select>
    );
}



export default SelectCentrosCostos;